<template>
  <div class="text-slate-900 dark:bg-neutral-900 dark:text-white dark:text-opacity-90">
    <slot></slot>
  </div>
</template>

<script setup lang="ts"></script>
